import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contentfrom";
import { Link } from "gatsby";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Let’s talk about your project</h2>
            </div>
            <p>
              Ready to bring your vision to life? Let's talk about your project
              and explore how our{" "}
              <Link to="https://www.tekrevol.com/sa/mobile-apps-development-in-saudi-arabia">
                mobile app development
              </Link>
              and web development services in KSA can create an impact on the
              digital presence of your business. Whether you need a stunning
              website or a customized web application, our team at TekRevol is
              here to cooperate with you every step of the journey. So, get in
              touch with us today to discuss your project and take a leap
              towards the digital excellence of your business.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
